import React, { useRef } from "react";
import styles from "./Styles.module.css";

const ModalDescription = ({ info = "", clouse }) => {
  return (
    <section className={styles.modalcontainer}>
      <div style={{ overflow: "hidden" }}>
        <h2>{info?.cardName ? info?.cardName : info.title}</h2>
        <section
          style={{ maxHeight: "100%", overflowY: "auto", padding: "1vw" }}
        >
          {info.descriptionImage && (
            <img
              src={`${info.descriptionImage}`}
              onError={() => {
                const img = new Image();
                img.src = info.descriptionImage;
              }}
              alt="Если не загрузился результат, нажмите назад и зайдите еще раз"
            />
          )}
          {info.cardDescription instanceof Array ? ( // если пришедший тип это массив
            <>
              {info.cardDescription.map((el, index) => (
                <div
                  key={index}
                  style={{ gap: 0, margin: "1vh 0", alignItems: "flex-start" }}
                >
                  <p style={{ fontWeight: "bold" }}>{el.head}</p>
                  <p style={{ maxWidth: "600px" }}>{el.description}</p>
                  <img src={el.image} alt="" />
                </div>
              ))}
            </>
          ) : (
            <p>
              {info.cardDescription == "При осмотре:" ? (
                <b>{info.cardDescription}</b>
              ) : info.cardDescription == "1" ? (
                <>
                  <p>
                    Данные жалобы беспокоят в течение нескольких дней, возникли
                    через 1 неделю после эпизода переохлаждения.
                    <br /> Пациентка отмечает, что подобные симптомы не впервые.
                    Обострение может возникать на фоне стресса, переохлаждения,
                    иногда после полового акта.
                    <br /> В анамнезе хронический цистит последние 3 года. Со
                    слов пациентки в течение года могут возникать 3-4 эпизода
                    обострения цистита. Последний эпизод обострения – 4 недели
                    назад, лечилась самостоятельно (амоксициллин,
                    фитопрепараты). У уролога постоянно не наблюдалась.
                  </p>
                </>
              ) : info.cardDescription ? (
                info.cardDescription
              ) : (
                info
              )}
            </p>
          )}

          {info?.typesDescription?.map((el, index) => {
            return (
              <section className={styles.sectionTypes} key={index}>
                <span style={{ fontWeight: "bold" }}>{el.type}</span>{" "}
                <span>{el.description}</span>
              </section>
            );
          })}
        </section>
      </div>
      <button
        style={{ marginTop: "10px" }}
        onClick={() => {
          clouse(null);
        }}
        className="buttonBack"
      >
        Назад
      </button>
    </section>
  );
};

export default ModalDescription;
